import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEvent } from '@wix/da-bi/pkg/events';

import s from './SocialButtonIconViewBase.scss';

export interface Props {
  biData?: BiEvent;
  className?: string;
  onClick: (e) => void;
}

const SocialButtonIconViewBase: React.FC<React.PropsWithChildren<Props>> = ({
  biData,
  className,
  onClick,
  children,
}) => {
  return (
    <BiButton className={c(s['root'], className)} biData={biData} onClick={onClick} type="button" />
  );
};
SocialButtonIconViewBase.displayName = 'SocialButtonIconViewBase';

export default SocialButtonIconViewBase;
